// @ngInject
function stateConfig($stateProvider) {
    $stateProvider.state('base.shippingmethods', {
        url: '/shippingmethods?searchTerm',
        views: {
            'baseList': {
            templateUrl: 'main/base/shippingmethods/shippingmethods.tpl.html',
            controller: 'ShippingMethodsController as vm'
        }},
        resolve: {
            shippingmethods: shippingmethodsResolver,
            searchTerm: searchTermesolver
        }
    });
}

// @ngInject
function shippingmethodsResolver(ShippingMethodsApiService, $stateParams) {
    return ShippingMethodsApiService.getShippingMethods({ page: 0, searchTerm:$stateParams.searchTerm, pageSize: null});
}

// @ngInject
function searchTermesolver($stateParams) {
    return $stateParams.searchTerm;
}

// @ngInject
function ShippingMethodsController($rootScope, $state, $scope, shippingmethods, ShippingMethodsApiService, loadSpinnerService,searchTerm) {
    var vm = this;

    vm.currentUser = $rootScope.currentUser;

    vm.shippingmethods = shippingmethods;
    vm.selectedShippingMethodId = 0;
    vm.searchTerm = (searchTerm) ? searchTerm : '';
    vm.currentPage = 1;

    vm.searchTermChange = searchTermChange;

    activate();

    function activate() {
        $scope.$watch(function() { return $state.params.shippingMethodId; }, function(newValue, oldValue) {
            vm.selectedShippingMethodId = parseInt($state.params.shippingMethodId,10);
        });
        $rootScope.$on('ShippingMethod.Inserted', function(event, response) {
        });
        $rootScope.$on('ShippingMethod.Updated', function(event, response) {
        });
        $rootScope.$on('ShippingMethod.Deleted', function(event, response) {
        });
        $rootScope.$on('ShippingMethod.Changed', function(event, response) {
            loadShippingMethods();
        });
    }

    function loadShippingMethods() {
        loadSpinnerService.start('mainSpinner');
        var request = { page: (vm.currentPage - 1), searchTerm:vm.searchTerm, pageSize:vm.itemsPerPage};
        ShippingMethodsApiService.getShippingMethods(request).then(function(response) {
            vm.shippingmethods = response;
        }).finally(function () {
            loadSpinnerService.stop('mainSpinner',{force: true});
        });
    }

    function searchTermChange() {
        vm.currentPage = 1;
        loadShippingMethods();
    }

}

angular
    .module('base.shippingmethods', ['shippingmethods.api','shippingmethods.shippingmethod'])
    .config(stateConfig)
    .controller('ShippingMethodsController', ShippingMethodsController);
